import React from 'react';
import {
  Button, Typography, Icon, Dialog, DialogContent, IconButton,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import DeleteIcon from '../../assets/img/delete_icon.svg';
import * as utilFunctions from '../../utils/Functions';
import { deleteConfirmationDialogStyles } from '../../css/style';

import withWidth from '@material-ui/core/withWidth';

const styles = deleteConfirmationDialogStyles();

export const DeleteConfirmDialog = (props) => {
  const {
    isDialogOpen, onCloseDialog, deleteDataName, resourceName, onClickConfirmButton, width,
  } = props;
  const singularResourceName = utilFunctions.depluralizeResourceName(resourceName);
  const dialogTexts = {
    order: {
      getTextConfirm: () => 'YES, CANCEL ORDER',
      getDescription: () => 'Are you sure you want to cancel this order?',
      getDetail: () => 'Cancelling the order will issue a refund to the customer',
      getTitle: () => 'CANCEL ORDER',
      getTextCancel: () => 'back',
    },
    user: {
      getTextConfirm: () => 'YES, DELETE ADDRESS',
      getDescription: () => 'Are you sure you want to delete this address?',
      getDetail: () => deleteDataName,
      getTitle: () => 'DELETE ADDRESS',
      getTextCancel: () => 'cancel',
    },
    default: {
      getTextConfirm: () => `Yes, delete ${singularResourceName}`,
      getDescription: () => `Are you sure you want to delete the ${singularResourceName} below?`,
      getDetail: () => deleteDataName,
      getTitle: () => `DELETE ${singularResourceName.toUpperCase()}`,
      getTextCancel: () => 'cancel',
    },
  };
  const dialogStyles = {
    order: {
      descriptionStyle: styles.cancelOrderDialogDescription,
      dataToDeleteStyle: styles.dialogDescription,
    },
    default: {
      descriptionStyle: styles.dialogDescription,
      dataToDeleteStyle: styles.dataToBeDeleted,
    },
  };
  const isTabletStyle = (width === 'md' && resourceName === 'locations') ? styles.deleteConfirmationDialogContainerTablet : styles.deleteConfirmationDialogContainer;
  const styleTypeKey = ['order'].includes(singularResourceName) ? singularResourceName : 'default';
  const getDialogText = (resourceType, textType) => {
    const typeKey = ['user', 'order'].includes(resourceType) ? resourceType : 'default';
    return dialogTexts[typeKey][`get${textType}`]();
  };
  return (
    <Dialog
      maxWidth="xl"
      open={isDialogOpen}
      onClose={() => onCloseDialog()}
    >
      <DialogContent style={isTabletStyle}>
        <IconButton
          style={styles.closeButton}
          onClick={() => onCloseDialog()}
        >
          <Icon>close</Icon>
        </IconButton>
        <img
          src={DeleteIcon}
          alt="Delete_Icon"
          style={styles.dialogImage}
        />
        <Typography style={styles.dialogTitle}>
          {getDialogText(singularResourceName, 'Title')}
        </Typography>
        <Typography style={dialogStyles[styleTypeKey].descriptionStyle}>
          {getDialogText(singularResourceName, 'Description')}
        </Typography>
        <Typography style={dialogStyles[styleTypeKey].dataToDeleteStyle}>
          {getDialogText(singularResourceName, 'Detail')}
          </Typography>
        <Button
          style={styles.confirmButton}
          onClick={() => onClickConfirmButton()}
        >
          {getDialogText(singularResourceName, 'TextConfirm')}
        </Button>
        <Typography
          style={styles.cancelText}
          onClick={() => onCloseDialog()}
        >
          {getDialogText(singularResourceName, 'TextCancel')}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

DeleteConfirmDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func,
  onClickButton: PropTypes.func,
  deleteDataName: PropTypes.string,
  resourceName: PropTypes.string,
};

DeleteConfirmDialog.displayName = 'DeleteConfirmDialog';

DeleteConfirmDialog.defaultProps = {
  isDialogOpen: false,
};

export default withWidth()(DeleteConfirmDialog);
